import _ from "lodash";
import {
  CAN_MANAGE_STUDENT_GOALS,
  CAN_VIEW_STUDENT_GOALS,
} from "Constants/permissionConstants";
import { getSelectedCurriculumProgramIds } from "HomePage/modules/HomePageUtils";
import {
  getPermissionEnabledInAnyCurriculum,
  getModuleEnabledInAnyCurriculum,
  getFilteredUserCurriculumProgramIds,
} from "Platform/modules/PlatformUtils";

export const findGoalById = (goals, selectedId) => {
  for (const goal of goals) {
    if (goal.id === selectedId) {
      return goal;
    }

    for (const task of goal.goalTasks) {
      if (task.id === selectedId) {
        return goal;
      }
    }
  }

  return {}; // Return {} if the selected ID is not found
};

export const getSelectedGoalItem = (data, selectedItemId) => {
  try {
    const studentGoals = _.map(
      _.get(data, "studentGoalsV2.edges", []),
      edge => edge.node
    );

    return findGoalById(studentGoals, selectedItemId);
  } catch (e) {
    return {};
  }
};

export const canManageStudentGoals = curriculumProgramIds => {
  return getPermissionEnabledInAnyCurriculum({
    curriculumProgramIds,
    permission: CAN_MANAGE_STUDENT_GOALS,
  });
};

export const canViewStudentGoals = curriculumProgramIds => {
  return getModuleEnabledInAnyCurriculum({
    curriculumProgramIds,
    module: CAN_VIEW_STUDENT_GOALS,
  });
};

export const getCurriculumIdsWithManageStudentGoalsAccess = state => {
  const curriculumProgramIds = getSelectedCurriculumProgramIds(state);

  const curriculumIdsWithViewAccess = getCurriculumIdsWithViewStudentGoalsAccess(
    state
  );
  const curriculumIdsWithManageAccess = getFilteredUserCurriculumProgramIds({
    permission: CAN_MANAGE_STUDENT_GOALS,
    curriculumProgramIds,
  });

  return _.intersection(
    curriculumIdsWithViewAccess,
    curriculumIdsWithManageAccess
  );
};

export const getCurriculumIdsWithViewStudentGoalsAccess = state => {
  const curriculumProgramIds = getSelectedCurriculumProgramIds(state);

  return getFilteredUserCurriculumProgramIds({
    module: CAN_VIEW_STUDENT_GOALS,
    curriculumProgramIds,
  });
};

export const getIsAllCourseDisabled = ({
  studentCourses,
  type = "student",
}) => {
  return _.every(studentCourses, course => {
    const multiValue = _.get(
      course,
      "primaryGrade.configurations.0.multiPlatformCategorizedValues",
      {}
    );
    const value = multiValue[type] ?? multiValue.default;
    return value === "false";
  });
};
